import classNames from 'classnames';
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { ValidationContext } from './validation-context';

/**
 * Represents a container for a validation component
 * @param {*} props - See propTypes definition.
 * @returns {ReactNode} ValidationContainer UI.
 */
export const ValidationContainer = ({
  rule,
  id,
  className,
  children,
}) => {
  const { currentValidationRuleName } = useContext(ValidationContext) || {};

  return useMemo(
    () => (
      currentValidationRuleName === rule
        ? (
          <div
            id={id}
            className={classNames('validation-container', className)}
            data-validation-rule={rule}
          >
            {children}
          </div>
        ) : null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentValidationRuleName, rule, id, className]
  );
};

ValidationContainer.propTypes = {
  /**
   * Unique identifier for this validation container
   */
  rule: PropTypes.string.isRequired,
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

ValidationContainer.defaultProps = {
  id: null,
  className: null,
};
